import React from "react";
import classes from "./FilteredWrapper.module.css";

const FilteredWrapper = (props) => {
  const { setSelectedFilters, selectedFilters, filtersListing } = props;

  if (!filtersListing) {
    return null;
  }

  const removeSelectedFilter = (filterValue) => {
    const updatedFilters = selectedFilters.filter(
      (selected) => selected !== filterValue
    );
    setSelectedFilters(updatedFilters);
  };

  const clearAllFilters = () => {
    setSelectedFilters([]);
  };

  const clearAll = (
    <div className={classes.action}>
      <button type="button" onClick={clearAllFilters}>
        <span>Clear all</span>
      </button>
    </div>
  );

  return (
    <>
      {selectedFilters && selectedFilters.length ? (
        <div className={classes.root}>
          <ul className={classes.currentFilters}>
            {selectedFilters.map((selectedFilter) => (
              <li key={selectedFilter} className={classes.item}>
                <span className={classes.current_filter}>
                  <span onClick={() => removeSelectedFilter(selectedFilter)}>
                    &times;
                  </span>
                  <span className={classes.text}>{selectedFilter.label}</span>
                </span>
              </li>
            ))}
          </ul>
          {clearAll}
        </div>
      ) : null}
    </>
  );
};

export default FilteredWrapper;
